import React, { useMemo } from 'react';
import { Typography, Box } from '@mui/material';
import { Doughnut } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import ChartPieChartOutlabels from "@energiency/chartjs-plugin-piechart-outlabels";

const COLORS = ['#3281B7', '#2E927C', '#EF9921', '#7EA8C2', '#73A59C', '#F7CC8B', '#E87934', '#666666', '#3599B8', '#DFBFBF', '#4AC5BB', '#5F6B6D', '#F4D25A', '#7F898A', '#A4DDEE', '#FDAB89'];

const FundTypeComposition = ({ data }) => {
  const chartData = useMemo(() => {
    const fundTypeTotals = data.reduce((acc, item) => {
      const fundType = item.fundType || 'Unknown';
      const currentValue = parseFloat(item.Cval_l);
      if (!acc[fundType]) {
        acc[fundType] = { name: fundType, value: 0 };
      }
      acc[fundType].value += currentValue;
      return acc;
    }, {});

    return Object.values(fundTypeTotals)
      .sort((a, b) => b.value - a.value)
      .map(item => ({
        ...item,
        value: Number(item.value.toFixed(2))
      }));
  }, [data]);

  const totalValue = useMemo(() => 
    chartData.reduce((sum, item) => sum + item.value, 0)
  , [chartData]);

  const fund_type_composition_data = {
    labels: chartData.map(item => item.name),
    datasets: [{
      data: chartData.map(item => item.value),
      backgroundColor: COLORS.slice(0, chartData.length),
    }]
  };

  const fund_type_composition_options = {
    animation: true,
    cutout: "40%",
    radius: "90%",
    layout: {
      padding: 50,
    },
    plugins: {
      outlabels: {
        display: true,
        text: "%l \n₹%v.2L (%p.2%)",
        color: "black",
        stretch: 2,
        font: {
          resizable: false,
          family: "Segoe UI",
          size: "15",
        },
      },
      tooltip: {
        enabled: true,
        backgroundColor: "white",
        bodyColor: "Black",
        titleColor: "Black",
        callbacks: {
          label: function(context) {
            const value = context.raw;
            const percentage = ((value / totalValue) * 100).toFixed(2);
            return `Current Value: ₹${value.toFixed(2)}L (${percentage}% of Total)`;
          }
        }
      },
      legend: {
        display: false,
        position: "right",
        align: "right",
      },
      datalabels: {
        display: false,
      },
    },
    responsive: true,
    maintainAspectRatio: false,
  };

  return (
    <Box sx={{ width: '100%', height: 320 }}>
      <Typography fontFamily={"Arial"} fontSize={18} fontWeight={"bold"} color={"Black"} height={"6%"} pb={1}>
        Fund Type Composition
      </Typography>
      <Doughnut 
        data={fund_type_composition_data} 
        plugins={[ChartDataLabels, ChartPieChartOutlabels]} 
        options={fund_type_composition_options} 
      />
    </Box>
  );
};

export default FundTypeComposition;